import { render, staticRenderFns } from "./TheHomeLayout.vue?vue&type=template&id=287b356d"
import script from "./TheHomeLayout.vue?vue&type=script&lang=js"
export * from "./TheHomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports